var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.params.data.userCategory),function(category,index){return _c('el-tag',{key:index,staticClass:"ml-2 el-button--primary",attrs:{"type":"primary","effect":"dark"}},[_vm._v(" "+_vm._s(category.name)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }